<template>
  <div class="driver-service-filter">
    <div class="box">
      <div class="label">Service type filter</div>

      <div class="filters">
        <div v-for="brand in brands" v-if="serviceList(brand.id).length" class="services">
          <div class="head" @click="toggleBrand(brand.id)">
            <i class="fas fa-angle-down" v-if="openBrand.indexOf(brand.id) > -1"></i>
            <i class="fas fa-angle-up" v-else></i>
            {{ brand.name }}
          </div>
          <transition name="height">
            <ul class="body" v-show="openBrand.indexOf(brand.id) > -1">
              <li v-for="service in serviceList(brand.id)" @click="toggleService(service.id)">
                <i :class="['fa-lg', selectedService.indexOf(service.id) > -1 ? 'fa-check-square fas' : 'far fa-square' ]"></i>
                {{service.label}}
              </li>
            </ul>
          </transition>
        </div>
      </div>

      <div class="fixed-bottom">
        <div class="row">
          <div class="column medium-6">
            <div class="button cta warning block small" @click="closeModal">Cancel</div>
          </div>
          <div class="column medium-6">
            <div class="button cta success block small" @click="applyFilters">Apply Filter</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import services from '@/modules/api/services'
import ApiDispatchDrivers from '@/modules/api/dispatch/drivers'

export default {
  name: 'driver-service-filter',
  data () {
    return {
      firstBrand: false,
      openBrand: [],
      // selectedService: [],
      hasToggleService: false
    }
  },
  computed: {
    brands () { return this.$store.state.brands.list },
    selectedService () { return this.$store.state.dispatch.serviceFilter.list }
  },
  methods: {
    serviceList (brandId) {
      let self = this
      let serviceList = self.$store.state.services.list.filter(x => x.brandId === brandId && x.enabled)
      if (!self.hasToggleService) {
        serviceList.forEach(service => {
          if (self.selectedService.indexOf(service.id) === -1) {
            // self.selectedService.push(service.id)
            self.$store.commit('dispatch/toggleServiceFilterList', service.id)
          }
        })
      }

      if (!self.firstBrand && serviceList.length) {
        self.openBrand.push(brandId)
        self.firstBrand = true
      }
      return serviceList
    },
    toggleBrand (brandId) {
      if (this.openBrand.indexOf(brandId) > -1) {
        let index = this.openBrand.indexOf(brandId)
        this.openBrand.splice(index, 1)
      } else {
        this.openBrand.push(brandId)
      }
    },
    toggleService (serviceId) {
      this.hasToggleService = true
      this.$store.commit('dispatch/toggleServiceFilterList', serviceId)
      // if (this.selectedService.indexOf(serviceId) > -1) {
        // let index = this.selectedService.indexOf(serviceId)
        // this.selectedService.splice(index, 1)
      // } else {
        // this.selectedService.push(serviceId)
      // }
    },
    closeModal () { this.$store.commit('dispatch/setServiceFilterShow', false) },
    applyFilters () {
      let self = this
      let openedDriverTable = self.$store.state.dispatch.driverListTabIndex
      let pageNumberMutation = 'dispatch/setOnDutyPageNumber'
      if (openedDriverTable === 1) {
        pageNumberMutation = 'dispatch/setStagingPageNumber'
      }
      if (openedDriverTable === 2) {
        pageNumberMutation = 'dispatch/setOffDutyPageNumber'
      }
      // Reset everything to page 1
      self.$store.commit(pageNumberMutation, 1)

      let data = {
        onDuty: openedDriverTable === 0,
        isStaging: openedDriverTable === 1
      }
      self.$store.commit('dispatch/setServiceFilterLoading', true)
      self.closeModal()
      ApiDispatchDrivers.getDriverListV2(self, data, r => {
        self.$store.commit('dispatch/setServiceFilterLoading', false)
        if (r.error) {
          console.log(r)
          return
        }
        self.$plugins.smoothScroll.scrollTo(document.getElementById('driver-list-container'))

        let mutation = 'dispatch/setOnDutyNoDriversFound'
        if (openedDriverTable === 1) {
          mutation = 'dispatch/setStagingNoDriversFound'
        }
        if (openedDriverTable === 2) {
          mutation = 'dispatch/setOffDutyNoDriversFound'
        }
        self.$store.commit(mutation, r.list.length <= 0)
      })
    }
  },
  mounted () {
    // let self = this
    // setTimeout(() => {
    //   self.applyFilters()
    // }, 2000)
  }
}
</script>

<style lang="scss" scoped>
.driver-service-filter{
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0,0,0, .5);
  width: 100%;
  height: 100%;
  z-index: 4;
  padding: 30px;
}
.box{
  width: 100%;
  padding: 15px 15px 50px;
  background: #fff;
  height: 100%;
  box-shadow: 0 0 3px rgba(0,0,0, .3);
  border-radius: 4px;
  position: relative;
}
.label{
  text-align: center;
  font-weight: 600;
  color: #0D79F2;
  margin-bottom: 15px;
}

.filters{
  height: calc(100% - 40px);
  overflow: auto;
}
.services{
  clear: both;

  .head{
    padding: 5px;
    background: #5ec1ac;
    color: #fff;
    border: 1px solid #3d8374;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;

    i{ margin-right: 5px; }
  }
  .body{
    list-style: none;
    margin: 0;
    padding: 5px 0;
    -webkit-column-count: 2;
    -moz-column-count: 2;
    column-count: 2;
    column-gap: 5px;
    background: #fff;
    border: 1px solid #3d8374;
    max-height: 999px;

    li{
      padding: 3px 10px;
      font-size: 13px;
      cursor: pointer;

      &:hover{ background: #f3f3f3; }
      i{
        vertical-align: middle;
        margin-right: 5px;
        &.fa-check-square{ color: #5ec1ac; }
      }
    }
  }
}

.fixed-bottom{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50px;
  padding: 7px 0;
  background: #333;
  .column{ padding: 0 10px; }
}

.height-enter-active, .height-leave-active { transition: all .2s ease; }
.height-enter, .height-leave-to {
  max-height: 0;
  opacity: 0;
}

@media only screen and (max-width: 430px) {
  .driver-service-filter {
    padding: 0;
  }
  .medium-6 {
    width: 50%;
  }

  .fixed-bottom {
    height: 70px;
    padding: 15px 0;
  }

  .filters {
    height: 100%;
    padding-bottom: 80px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dispatch/DriverServiceFilter.vue